import ApolloClient from 'apollo-boost'; //引入apollo-boost插件

//实例化apolloClient
const apolloClient = new ApolloClient({
  // 你需要在这里使用绝对路径
  uri: '/common-query/graphql'
})

//导出实例
export default apolloClient;


// WEBPACK FOOTER //
// ./src/graphql/utitl.js